import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ROUTER_DIRECTIVES} from '@angular/router';

import {UsuariosService} from '../usuarios/usuario.service';
import {Usuario} from '../usuarios/usuario';
import {Rol} from '../rol/rol';
import {LoginService} from '../login/login.service';
import {MiCuentaService} from "../miCuenta/miCuenta.service";

declare var $: any;

@Component({
    selector: 'cambiarPassword',
    template: require('../../app/cambiarPassword/cambiarPassword.component.html'),
    styles: [require('../../app/cambiarPassword/cambiarPassword.component.css')],
    directives: [ROUTER_DIRECTIVES]
})

export class CambiarPasswordComponent implements OnInit {
    usuario: Usuario;
    roles: Rol[];
    active: any;
    deshabilitar: boolean;

    constructor(private router: Router,
                private usuarioService: UsuariosService,
                private loginService: LoginService,
                private miCuentaService: MiCuentaService) {

    }

    ngOnInit() {
        //Busco usuario
        if(this.loginService.getDecodeToken().id)
        this.usuarioService
            .getUsuario(this.loginService.getDecodeToken().id)
            .subscribe(user => {
                this.usuario = user;
            });

        //Inicializar banderas para resetear forms
        this.active = true;

        //Seteo bandera para deshabilitar
        this.deshabilitar = false;

        //Detectar ojo pass
        $("#ojo").mousedown(function() {
            $(".noVisible").css("display", "none");
            $(".visible").css("display", "inline");
        });
        $("#ojo").mouseup(function() {
            $(".noVisible").css("display", "inline");
            $(".visible").css("display", "none");
        });

        $("#ojo2").mousedown(function() {
            $(".noVisible2").css("display", "none");
            $(".visible2").css("display", "inline");
        });
        $("#ojo2").mouseup(function() {
            $(".noVisible2").css("display", "inline");
            $(".visible2").css("display", "none");
        });
    }

    guardarCambios() {
        this.miCuentaService
            .cambiarPassword(this.usuario)
            .subscribe((usuario) => {
                this.usuario = usuario;
                this.loginService.logout();
            })
    }

    ojoDown(){
        $(".noVisible").css("display", "none");
        $(".visible").css("display", "inline");
    }

    ojoUp(){
        $(".noVisible").css("display", "inline");
        $(".visible").css("display", "none");
    }

    ojo2Down(){
        $(".noVisible2").css("display", "none");
        $(".visible2").css("display", "inline");
    }

    ojo2Up(){
        $(".noVisible2").css("display", "inline");
        $(".visible2").css("display", "none");
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/cambiarPassword/cambiarPassword.component.ts